import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import cx from 'classnames';
import slice from 'ramda/src/slice';
import Input from '@components/@core/Input';
import Button from '@components/@core/AnimatedButton';

class AutoComplete extends React.Component {
    state = {
        filteredOptions: [],
        showOptions: false,
        userInput: '',
    };

    handleChange = (userInput) => {
        const { options } = this.props;
        const filteredOptions = options.filter((option) => option?.name && option.name.toLowerCase().indexOf(userInput && userInput.toLowerCase()) > -1);
        this.setState({ userInput, filteredOptions, showOptions: true });
    };

    handleSearch = () => {
        const { userInput } = this.state;
        this.props.onSearch(userInput);
        this.setState({ showOptions: false });
    };

    handleClick = (option) => () => {
        this.props.onSearch(option);
        this.setState({
            filteredOptions: [],
            showOptions: false,
            userInput: option.name,
        });
    };

    render() {
        const { className, type, placeholder } = this.props;
        const { filteredOptions, showOptions, userInput } = this.state;
        const options = filteredOptions.length > 10 ? slice(0, 9, filteredOptions) : filteredOptions;

        return (
            <div className={cx('auto-search-complete', className)}>
                <div className="flex d-h-between">
                    <Input className="auto-search-input" value={userInput} placeholder={placeholder} onChange={this.handleChange} />
                    <Button name="Search" onClick={this.handleSearch} />
                </div>
                {showOptions && userInput && (
                    <div className={options.length === 0 ? 'search-options border rounded shadow' : 'search-options'}>
                        {options.map((option) => (
                            <div key={option.id} className="search-options-item" onClick={this.handleClick(option)}>
                                <Highlighter
                                    highlightClassName="dsl-m14 text-400 p-0 bg-none"
                                    unhighlightClassName="dsl-b14 text-600"
                                    searchWords={[userInput]}
                                    autoEscape={true}
                                    textToHighlight={option.name}
                                />
                            </div>
                        ))}
                        {options.length === 0 && (
                            <div className="text-center p-0 search-options-item no-option">
                                <p className="dsl-b14 mb-0">No {type}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

AutoComplete.propTypes = {
    className: PropTypes.string,
    options: PropTypes.array,
    type: PropTypes.string,
};

AutoComplete.defaultProps = {
    className: '',
    options: [],
    type: '',
};

export default AutoComplete;
